import React from "react";
import { Row, Col, Tabs, Card, Button, Avatar, Checkbox } from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Select, Number, Text } from "components/redux-form";
import { Field, getFormValues, reduxForm } from "redux-form";
import store from "store";
import { patchUser } from "../Module";

@reduxForm({
  form: "sms-number-form",
  onSubmit: (values, dispatch, props) => {
    console.log("valuesvalues", values);
    let loader = app.loading(
      app.translate("routes.home.feed.device.Updating Device")
    );

    if (values.date && values.time) {
      dispatch(
        request(props.device.id, "setDatetime", {
          datetime:
            values.date.substr(0, 4) +
            "-" +
            values.date.substr(5, 2) +
            "-" +
            values.date.substr(8, 2) +
            " " +
            values.time.substr(0, 8),
        })
      );
    }

    dispatch(
      request(props.device.id, "setSettings", values, (err) => {
        if (err) {
          loader.hide(() =>
            app.message(
              app.translate("routes.home.feed.device.Updating Device Failed"),
              "error"
            )
          );
        } else {
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.feed.device.Device updated Successfully"
              )
            )
          );
        }
      })
    );
  },
})
@connect(
  (state) => ({
    values: getFormValues("sms-number-form")(state),
    user: state.Basic.Personnel.user,
  }),
  {
    // show: showUser,
    // empty: emptyUser,
  }
)
@authorize
@autobind
/**
 *
 */
export default class Sms extends React.PureComponent {
  static propTypes = {
    personnel: PropTypes.object,
    can: PropTypes.func,
  };

  static defaultProps = {};

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      personnel: props.personnel ? [props.personnel] : [],
      loading: true,
      hasSend: this.props.item.profile.activeSms,
      phoneNumber: null,
    };
    if (this.personnelsRef) {
      this.personnelsRef.empty();
    }
  }

  /**
   *
   */
  componentWillUnmount() {
    super.componentWillUnmount();
  }
  onSubmit() {
    const { values, item } = this.props;
    const { hasSend } = this.state;

    const data = {
      user: {
        profile: { phone_number: values.phoneNumber, active_sms: hasSend },
      },
    };
    store.dispatch(
      patchUser(
        item.id,
        {
          profile: {
            phone_number: values.phoneNumber,
            active_sms: hasSend ? "1" : "0",
          },
        },
        () => this.setState({ loading: false })
      )
    );
  }
  /**
   *
   * @param {object} item
   * @private
   */
  _setPersonnel(item) {
    this.setState({ personnel: [item] });
  }
  componentDidMount() {
    this.setState({
      phoneNumber: this.props.user.profile?.phoneNumber,
    });
    const { initialize, user, company } = this.props;
    initialize({
      phoneNumber: this.props.item.profile?.phoneNumber,
    });
    // if (this.props.item.profile.length !== 0) {
    //   this.setState({
    //     loading: false,
    //   });
    // }
  }
  componentDidUpdate(prevProps, prevState) {
    console.log("lkjhgfd", this.props.user.profile?.phoneNumber);

    const { initialize, user, company } = this.props;
    if (
      prevProps.user.profile?.phoneNumber !==
        this.props.user.profile?.phoneNumber ||
      prevProps.user.profile?.activeSms !== this.props.user.profile?.activeSms
    ) {
      initialize({
        phoneNumber: this.props.user.profile?.phoneNumber,
      });
      this.setState({
        hasSend: this.props.item.profile?.activeSms,
      });
    }
    if (this.props.item.profile.length !== 0) {
      this.setState({
        loading: false,
      });
    }
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const { personnel, active, loading, hasSend } = this.state;
    const { can, item, title } = this.props;

    return (
      <Card
        style={{
          overflowY: "auto",
          height: "100%",
          margin: 0,
          border: "2px solid red",
        }}
        loading={loading}
        title={item?.profile?.firstName + " " + item?.profile?.lastName}
        extra={
          <Button.Group>
            <Button type="default">{app.translate("main.Cancel")}</Button>
            <Button type="primary" key="submit" onClick={this.onSubmit}>
              {app.translate("ثبت")}
            </Button>
          </Button.Group>
        }
      >
        <Row style={{ display: "flex", flexDirection: "column" }}>
          <Col md={12}>
            <Field
              key={"phoneNumber"}
              name="phoneNumber"
              label={app.translate("شماره اختصاصی پیامک ")}
              required
              component={Text}
              style={{ overflow: "hidden" }}
              mode="combobox"
              size={"default"}
              // filterOption={(str, option) => {
              //   return (
              //     str &&
              //     option.props &&
              //     option.props.children &&
              //     option.props.children.includes(str)
              //   );
              // }}
            />
          </Col>
          <Row
            md={8}
            style={{
              display: "flex",
              gap: "8px",
            }}
          >
            <div>برای فرد پیامک ارسال نشود </div>
            <Checkbox
              // disabled={!!locked}
              name="activeSms"
              checked={hasSend ? hasSend : false}
              onChange={(e) => {
                console.log("e.target.checked", e.target.checked);
                this.setState({
                  hasSend: e.target.checked,
                });
                // let changedData = Sms[index];
                // changedData.check = e.target.checked;
                // let changedStatus = Sms.slice();
                // changedStatus.splice(index, 1, changedData);
                // this.setState({ Sms: changedStatus });
              }}
            />
          </Row>
        </Row>
      </Card>
    );
  }
}
